import CheckIcon from '@mui/icons-material/Check'
import { Box, CircularProgress, styled } from '@mui/material'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const Container = styled(Box)`
  display: flex;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
`

const LoadingContainer = styled(Box)`
  position: relative;
  width: 30px;
  height: 30px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 20px;
`

const StyledCheckIcon = styled(CheckIcon)`
  color: white;
  position: absolute;
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-top: 5px;
`

const StepNumber = styled(Box)`
  color: white;
  position: absolute;
  width: 30px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  text-align: center;
`

const StyledCircularProgressBackground = styled(CircularProgress)`
  position: absolute;
  color: #39c522;
`

const StyledCircularProgressforeground = styled(CircularProgress)`
  position: absolute;
  color: #d0d0d0;
`

const StepTitle = styled(Box)`
  color: white;
  font-size: 16px;
  line-height: 30px;
`

const StepHint = styled(Box)`
  color: #838383;
  font-size: 16px;
`

const TradeBuyStepView: FC<Props> = (props: Props) => {
  const { className, stepNumber, isDone, stepTitle, stepHint } = props

  const { t } = useTranslation()

  return (
    <Container className={className}>
      <LoadingContainer>
        {isDone ? <StyledCheckIcon /> : <StepNumber>{stepNumber}</StepNumber>}
        <StyledCircularProgressBackground
          size={30}
          thickness={5}
          value={100}
          variant='determinate'
        />
        {!isDone && (
          <StyledCircularProgressforeground
            size={30}
            thickness={5}
            variant='indeterminate'
            disableShrink
          />
        )}
      </LoadingContainer>
      <Box>
        <StepTitle>{t(stepTitle)}</StepTitle>
        <StepHint>{t(stepHint)}</StepHint>
      </Box>
    </Container>
  )
}

type Props = {
  className?: string
  isDone: boolean
  stepHint: string
  stepNumber: number
  stepTitle: string
}

export default TradeBuyStepView
